import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import Grid from '@mui/material/Grid';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import type React from 'react';
import { useState } from 'react';
import type { ConversationEval } from 'services/types/conversationEvals';
import { AI_MODELS, DEFAULT_AI_MODEL, DEFAULT_EVALUATION_AI_MODEL } from 'utils/aiModels';

interface RunEvaluationFormProps {
  conversationEval: ConversationEval | null;
  onClose: () => void;
  onRunEvaluation: (params: {
    completionAIModel?: string;
    evaluationAIModel?: string;
    threshold?: number;
    limit?: number;
    offset?: number;
  }) => void;
}

const RunEvaluationForm: React.FC<RunEvaluationFormProps> = ({ conversationEval, onClose, onRunEvaluation }) => {
  const [formData, setFormData] = useState({
    completionAIModel: DEFAULT_AI_MODEL,
    evaluationAIModel: DEFAULT_EVALUATION_AI_MODEL,
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onRunEvaluation(formData);
  };

  if (!conversationEval) {
    return null;
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ pt: 2 }}>
      <Typography variant="h6" gutterBottom>
        Configuración de Evaluación
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: 'text.secondary',
          mb: 3,
        }}
      >
        Evaluación #{conversationEval.id} - {conversationEval.messages.length} mensajes
      </Typography>
      <Grid container spacing={3}>
        <Grid size={12}>
          <FormControl fullWidth>
            <InputLabel>Modelo de Completación</InputLabel>
            <Select
              value={formData.completionAIModel}
              onChange={(e) => setFormData({ ...formData, completionAIModel: e.target.value })}
              label="Modelo de Completación"
            >
              {AI_MODELS.map((modelName) => (
                <MenuItem key={modelName} value={modelName}>
                  {modelName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>

        <Grid size={12}>
          <FormControl fullWidth>
            <InputLabel>Modelo de Evaluación</InputLabel>
            <Select
              value={formData.evaluationAIModel}
              onChange={(e) => setFormData({ ...formData, evaluationAIModel: e.target.value })}
              label="Modelo de Evaluación"
            >
              {AI_MODELS.map((modelName) => (
                <MenuItem key={modelName} value={modelName}>
                  {modelName}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
      </Grid>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          gap: 2,
          mt: 3,
        }}
      >
        <Button onClick={onClose} variant="outlined">
          Cancelar
        </Button>
        <Button type="submit" variant="contained">
          Ejecutar Evaluación
        </Button>
      </Box>
    </Box>
  );
};

export default RunEvaluationForm;
